import React, { forwardRef, useImperativeHandle, useState, useEffect, useRef } from 'react';
import { useDispatch, useSelector } from 'react-redux'
import * as a from 'actions/livefeedapi';

import Modal from 'components/common/modal';
import Select from 'react-select';

const EditUserForm = forwardRef((props, ref) => {
	const dispatch = useDispatch();
	const { urls } = useSelector(state => state.livefeedAPIReducer)
	const deleteUserModal = useRef(null)
	const editUserModal = useRef(null)
	const [componentState, setComponentState] = useState({
		livefeedName: null, index: null, key: null, subscribers: [],
		prevSubscribers: null, isLoading: false, deletedUser: null
	})

	useImperativeHandle(ref, () => ({
		openEditUserModal: (index) => {
			const { key, subscribers, name } = urls[index];
			setComponentState({
				...componentState,
				livefeedName: name,
				index: index,
				key: key,
				subscribers: [],
				prevSubscribers: subscribers
			})
			editUserModal.current.open();
		}
	}));
	//----------------------------------------- delete user functions  handle
	function makeHandlerUserDelete(email) {
		setComponentState({
			...componentState,
			isLoading: true
		})
		setComponentState({
			...componentState,
			deletedUser: email
		})
		deleteUserModal.current.open()
	}
	function handleDeleteUser(key, email) {
		/*
			Format :
				key : "2e6010cf-1766-46bc-bbad-9d3fd638df1c"
				email : "quangdel@gmail.com" // must be one string.
		*/
		dispatch(a.removeUserFromURL(key, email, () => {
			setComponentState({
				...componentState,
				isLoading: false
			})
			deleteUserModal.current.close()

		}));
	}
	//----------------------------------------- add user function  handle
	function handleAddUser(key, emails) {
		/*
			Format :
				key : "2e6010cf-1766-46bc-bbad-9d3fd638df1c"
				emails : ["quangdel@gmail.com"] // must be an array of strings.
		*/
		emails = emails.map((x) => x.value);

		dispatch(a.addUsersToURL(key, emails, () => {
			setComponentState({
				...componentState,
				isLoading: false
			})
		}));
	}

	useEffect(() => {
		// update prevSubscribers if there is changes from urls[componentState.index].subscribers.length
		if (urls[componentState.index] &&
			urls[componentState.index].subscribers.length !== componentState.prevSubscribers.length) {
			const { subscribers: prevSubscribers } = urls[componentState.index];
			setComponentState({
				...componentState,
				prevSubscribers: prevSubscribers,
				subscribers: []
			})

		}
	}, [componentState, urls])
	return (
		<Modal
			ref={editUserModal}
			clickButton={() => {
				if (!componentState.isLoading && componentState.subscribers.length > 0) {
					setComponentState({ ...componentState, isLoading: true })
					handleAddUser(componentState.key, componentState.subscribers);
				}
			}}
			header={"Edit users"}
			buttonText={"Add"}
			buttonClass={`btn-success ${componentState.subscribers.length > 0 ? '' : 'btn-disabled'}`}
			disableCloseButton={true}
			entry={null}
		>
			<div className="live-feed-form">
				<div>
					<p>Livefeed name : {componentState.livefeedName}</p>
					<span className="input-label">Current user(s)</span>
					<div className="input-current-container">
						{componentState.prevSubscribers && componentState.prevSubscribers.map((subscriber, i) => {
							return (
								<div key={"key-user-" + subscriber} className="input-current-user">
									{subscriber}
									<i className="material-icons" onClick={() => makeHandlerUserDelete(subscriber)}>
										clear
										</i>
								</div>
							)
						})
						}
					</div>
				</div>
				<div>
					<span className="input-label">Add user(s)</span>
					<Select.Creatable
						multi
						closeOnSelect={true}
						onChange={(value) => setComponentState({ ...componentState, subscribers: value })}
						options={[]}
						placeholder="viewing@user.com"
						removeSelected={true}
						value={componentState.subscribers}
						arrowRenderer={() => { }}
						noResultsText={"Enter each email then press 'Enter'"}
					/>
					{componentState.isLoading && "Please Wait..."}
				</div>
				<Modal
					ref={deleteUserModal}
					clickButton={() => handleDeleteUser(componentState.key, componentState.deletedUser)}
					header="Remove user"
					buttonText="Delete"
					buttonClass="btn-danger"
					entry={null}
				>
					<p><b>Removing and re-adding the same users can cause errors.</b><br></br>Are you sure you want to remove user "{componentState.deletedUser}" from the livefeed ?</p>
				</Modal>
			</div>

		</Modal>
	);
})
export default EditUserForm;


// WEBPACK FOOTER //
// ./src/components/pages/livefeed/SwitchTab/LivefeedTableList/EditUserForm.jsx